var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGimini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_145_1144)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0.304199,
    width: 51,
    height: 51,
    rx: 10,
    fill: "url(#pattern0)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_145_1144",
    x: 0,
    y: -0.695801,
    width: 59,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_145_1144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_145_1144",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_145_1144"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.224566 0 0 0 0 0.748935 0 0 0 0 0.829167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_145_1144",
    result: "effect3_innerShadow_145_1144"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_145_1144",
    transform: "scale(0.0135135)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_145_1144",
    width: 74,
    height: 74,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABKCAYAAAAc0MJxAAAEIElEQVR4Ae2b/23VMBDHOw0TsAATsAAMAAvAAiwAC7AALFAWYAH4CyGkUlUVqkpVVby+92r0ecjScTiJmzvHETpLUX48x/F9fN/zOWmPHnzZpNimGRwFpGlIMApQlYoKUAGqTlK1oSc8KjwqPKpLOhPSC+mF9EJ6tVN1j3oRoyJGRYyKGKVjz8Ovm/TsbJteX+wO28ebfXp7+ef41Y9devTtdjFoq4xRT0+36fh6n2rKp193CWhA1aA9z1cF6vHJbcJr5pSf+5RenO+awVoNKLxirFzt0wHi9+3dWLVDnRbetQpQ767+hQSYNxe7hAxLhnP95fkulcAhR7zzv5JeCdKH6/29AjVAASsLsEqA58Lr6lFabhiLp8wxhhnw8+ZvWRLv5rRVuqcbKAwjAMsyF1I2DA/SUkSe+XfLvhuo9you4V0WQ/K9xCYpQwbDQ4JdQOFNshCTsqEee7xIFo9B6AKK4CuL9wwFbClBArt1ALqAouO5YJDViNL9LHVksS53uoCSBmBQyVDrNbxUFqv8FgelUwLOn5xum2xyVkXuFvjNQeHyrP6l3ORIL3Vs9dxmoABUyrqXAqOfY00+m4BCTtLtdad7nK9OekNeRK4EQB2jauOGhFubwcvBWhWoEiS9wMVIWVqB0rPe87N5a8jcPzfpaU9hGVHq3FKgdB6VDZ67dwGlRw9IQ9n2EqBY20nZeSyRXEDp17dDkBjNJUBpb+KZcz0p32cGpQ2fCpq6fu7I1F7GtTHDdfvWtCD3ywwKt84FyU290tCG5I5M7fMz2A+BwpOl5Kg75t1Tz5S/m0ABRZYpb+LBrUDxakVDYoKRxlqOTaCY1WSpGT1vUKwASt8AeTFoAaPvNYHCg3JBdrrx0rkHqJy46kkk98UbEna4gcqd7LlnsDzlJgfaBGpoRHvAwoumJhJp+H2PTaB0vrI0ID5PIX/r28saaCZQMkYx4xB/Wmx6edRKXmPATKC0ATWz3lhnhn7Tzxmq1/K6CRQuL4v1LeKQoTKpRW5D9VpeN4GiY/Iz9kmDLyp6MGqS2hbAzKC0LEqvViwd18nkEoG71F8zKKZk8pdcCOpesUpn/i0SyRKU0jUzKBrVn7CRoDWnAbZcuzEYvbwJG11A0ZBOPvk8NdcwUgwJCW/tkRJIz3IDhQfJwI5xGMs3PfnAsWPaoL4uPSWX++sGigaRi4aF0UiRP0Tli3B+sNxzH4C0F3HvGiDRV1dQNIhXaBlqDwEcdabq9ZabHEx3ULlxArycDTWssXMAes2cuT/WfTNQdAzvwitKciyBIgMnkFuNanF/U1Cyw8yAQCOzZqmD13DM5p2kyud6HS8GyqvDvdoJUPH/er7/RBQeFR4VHtUlfQjphfRCeiG9XslkzXMjRkWMihgVMaomVvSqEzGqMkb9BpYKSX1lh1q2AAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGimini);
export default __webpack_public_path__ + "static/media/gimini.71881a110f8477102d79e056b6198f89.svg";
export { ForwardRef as ReactComponent };